import { FC } from "react";

import { CMSIntegrations } from "@/components/web-experience/cms-integrations";

export const Integrations: FC = () => (
  <div className="flex-1 border-x p-8 overflow-y-scroll">
    <h3 className="text-2xl font-medium mb-4">Integrations</h3>
    <CMSIntegrations />
  </div>
);
